import BroadcastUserInfo from "./BroadcastUserInfo";

export default class EcrisNous
{
    constructor()
    {
        this.bindEvents();
    }

    bindEvents ()
    {
        this.fctFormReady = this.onFormReady.bind(this);
        this.bui = new BroadcastUserInfo();
        this.bui.addListener(this.onProfileChange.bind(this))

        window.addEventListener("form-ready", this.fctFormReady)
    }

    onProfileChange (event)
    {
        const data = event.data;

        if (this.formEcrisNous)
        {
            if ("name" in data)
            {
                this.formEcrisNous.hydrateField("nom", data.name)
            }
            else if ("email" in data)
            {
                this.formEcrisNous.hydrateField("courriel", data.email)
            }
        }
    }


    onFormReady (e)
    {
        if (e.detail.form_id === "4")
        {
            this.formEcrisNous = e.detail;
            this.hydrateFields(e.detail);
        }
    }



    hydrateFields (e)
    {
        if ( typeof AsGlobalSettings === 'undefined'
             || typeof AsGlobalSettings.isAuthenticated === 'undefined'
             || !AsGlobalSettings.isAuthenticated )
        {
            // not logged in, nothing to hydrate
            return;
        }

        e.hydrateField("nom", AsGlobalSettings.user.name )
        e.hydrateField("courriel", AsGlobalSettings.user.email )

    }
}
